import { inactiveStatus } from "@/features/appointments/utils";
import { type AppointmentStatus } from "@repo/api";

export const isActiveStatus = (status?: AppointmentStatus): boolean =>
  status !== undefined && !inactiveStatus.includes(status);
